import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: calc(100% - 60px);
  margin-top: 60px;
  font-size: 1.6rem;
  border-radius: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 10px;
  transition: 3ms linear;
  z-index: 4;
`;
